var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts"},[_c('IEcharts',{attrs:{"id":"graph11","option":_vm.bar,"loading":_vm.loading,"theme":_vm.theme,"resizable":_vm.resizable},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }